export type ChecklistOption = { status: boolean; step: string };

export type ChecklistOptions = ChecklistOption[];

export enum ChecklistItems {
  SELECTED_LOGIN_METHOD = 'selected_login_method',
  SET_CALLBACK_URL = 'set_callback_url',
  SET_UP_OAUTH = 'set_up_oauth',
  COPY_SECRET_KEY = 'copy_secret_key',
  CONNECTED_SOCIAL = 'connected_social',
  MISCELLANEOUS_DATA = 'miscellaneous_data',
  SET_UP_STORAGE = 'set_up_storage',
  SUPPLEMENTARY_INFO = 'supplementary_info',
  WIDGET_CUSTOMIZATION = 'widget_customization'
}
